import { Injectable } from '@angular/core';
import { ApiCommodityFamily } from '@app/infrastructure/api/models';
import { SetSpotPositionsListConfig } from '@app/routes/index/spot-positions/index/_actions';
import { State, Selector, Action, StateContext } from '@ngxs/store';

export const CURRENT_SPOT_POSITIONS_LIST_VERSION = 1;

interface SpotPositionsListStateModel {
  version: number;
  commodityId?: string;
  commodityFamily?: ApiCommodityFamily;
}

export const SPOT_POSITIONS_LIST_STATE_DEFAULTS: SpotPositionsListStateModel = {
  version: CURRENT_SPOT_POSITIONS_LIST_VERSION,
  commodityId: undefined,
  commodityFamily: undefined,
};

@State<SpotPositionsListStateModel>({
  name: 'SpotPositionsList',
  defaults: SPOT_POSITIONS_LIST_STATE_DEFAULTS,
})
@Injectable()
export class SpotPositionsListState {
  @Selector()
  static commodityId(state: SpotPositionsListStateModel): string | undefined {
    return state.commodityId;
  }

  @Selector()
  static commodityFamily(state: SpotPositionsListStateModel): ApiCommodityFamily | undefined {
    return state.commodityFamily;
  }

  @Action(SetSpotPositionsListConfig)
  setSpotPositionsListConfig(
    ctx: StateContext<SpotPositionsListStateModel>,
    action: SetSpotPositionsListConfig,
  ) {
    ctx.patchState({
      commodityId: action.config.commodityId,
      commodityFamily: action.config.commodityFamily,
    });
  }
}
